<template>
	<v-row class="text-center d-flex align-center" no-gutters>
		<v-col cols="12">
			<h1 class="display-2 font-weight-bold mb-3">{{ $t('homeview.welcome') }}</h1>
			<v-img :src="require('../assets/logo.svg')" class="my-3" contain height="200" />
			<p class="subheading font-weight-regular">
				{{ $t('homeview.textvisit') }} <a href="https://www.feriavalencia.com/" target="_blank">{{ $t('homeview.website') }}</a>
			</p>
		</v-col>
	</v-row>
</template>

<script>
export default {
	name: 'Home'
};
</script>
